<div id="appointments">
  <p class="home-section-subtitle">
    <span class="title-label">
      {{'Awaiting_actions' | translate}}
    </span>
    <span class="see-all"
      (click)="seeAll()">
      {{'See_all' | translate}}
      <img class="title-icon" src="assets/icons/slot/right_arrow.svg" alt="arrow">
    </span>
  </p>
  <div class="appt-list-view" *ngIf="!showAsSlide">
    <div class="appt-list-card" *ngFor="let item of awaitingList">
      <ng-container [ngTemplateOutlet]="APPTCARD" [ngTemplateOutletContext]="{item:item}"></ng-container>
    </div>
  </div>
  <div class="swiper appt-list-view" *ngIf="showAsSlide" #apptSwiper>
    <div class="swiper-wrapper" *ngIf="awaitingList?.length > 0">
      <div class="swiper-slide appt-list-card-slider" *ngFor="let item of awaitingList">
        <ng-container [ngTemplateOutlet]="APPTCARD" [ngTemplateOutletContext]="{item:item}"></ng-container>
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
</div>

<ng-template #APPTCARD let-item="item">
  <div class="appt-list-card-for-slider">

    <span *ngIf="item['actionType'] == 'PACKSUBSERVICE'">
    <div class="appt-card-header package-header" >
      <img class="type-image" src="assets/icons/packages/info_purple.svg" alt=""> {{'Book_your_next_service' | translate}}
    </div>
    <div class="appointment-content">
      <div class="person-avatar-wrapper">
        <img class="type-image" [src]="getIcon(item)" alt="">
      </div>
      <div class="appt-context">
        <div class="appt-title">{{item?.packageInfo?.packageObject?.name | translate : 'LANGARRAY': 'name'}}</div>
      </div>
      <div class="item-detail">
        <div class="timeline-button">
            <ng-container>
              <button class="button-primary" (click)="openBookSubsequentAppt(item); $event.stopPropagation();">
                {{'Book_appointment'|translate}}
              </button>
            </ng-container>
        </div>
      </div>
    </div>
    <div class="appointment-for-content">
      <p class="appt-for"> {{'For:' | translate}}
        <span class="bold">{{item?._patientObj?.personname}}</span>
      </p>
    </div>
  </span>

    <span *ngIf="item['viewType'] == 'PACKAGECOUPON'">
    <div class="appt-card-header package-header">
      <img class="type-image" src="assets/icons/packages/info_purple.svg" alt=""> {{'Package_coupons_available' | translate}}
    </div>
    <div class="appointment-content pkg-coupon-content">
      <div class="person-avatar-wrapper">
        <img class="type-image" [src]="getIcon(item)" alt="">
      </div>
      <div class="appt-context">
        <div class="appt-title">{{item?.packageData?.concept?.name | translate : 'LANGARRAY': 'name'}}</div>
      </div>
      <div class="item-detail">
        <div class="timeline-button">
            <ng-container>
              <button class="button-primary" (click)="openBookSubsequentAppt(item); $event.stopPropagation();">
                {{'Review_&_Book_package'|translate}}
              </button>
            </ng-container>
        </div>
      </div>
    </div>
    <div class="appointment-for-content">
      <p class="appt-for"> {{''}}
        <span class="bold">{{''}}</span>
      </p>
    </div>
    </span>
  </div>
</ng-template>